import React from "react";
import { Loading } from "./Icons";
import "./LoadingScreen.css";

const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-container">
      <Loading />
      <p>Cargando...</p>
    </div>
  );
};

export default LoadingScreen;
